import GeoSpatialScatterRole from './geospatial-scatter';
import GeoSpatialHeatmapRole from './geospatial-heatmap';
import GeoSpatialChoroplethRole from './geospatial-choropleth';

const MAP_ROLES = [
  GeoSpatialScatterRole,
  GeoSpatialHeatmapRole,
  GeoSpatialChoroplethRole,
];

export default MAP_ROLES;
export { MAP_ROLES };
